import styled, { css } from 'styled-components';

import Message from './Message';
import Icon from '../Icon';

export default styled(Message)`
  padding: 0.75rem;
  font-size: 0.875rem;
  text-align: left;
  background-color: ${({ theme, bgColor }) => bgColor || theme.COLOR_BERRY_RED};
  color: ${({ theme }) => theme.COLOR_WHITE};
  font-weight: bold;
  letter-spacing: 0.5px;

  ${({ marginBottom }) => marginBottom && css`
    margin-bottom: 1rem;
  `}

  ${({ marginTop }) => marginTop && css`
    margin-top: 1rem;
  `}

  ${({ fullWidth }) => fullWidth && css`
    display: block;
    width: 100%;
  `}

  ${({ flex }) => flex && css`
    display: flex;
    gap: 0.75rem;
  `}
`;

export const WarningMessageIcon = styled(Icon)`
  & > svg {
    width: 24px;
    height: 24px;
  }
`;
